import { style } from '@vanilla-extract/css'

const note = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#828282',
})

const card = style({
  borderRadius: '16px',
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
})

const cardHeading = style({
  fontSize: '15px',
  fontWeight: '700',
})

const date = style({
  fontSize: '19px',
  fontWeight: '700',
})

const text = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const warn = style([
  text,
  {
    color: '#ED0006',
  },
])

const skipLink = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: '#ED0006',
  textDecoration: 'underline',
})

export const styles = {
  note,
  card,
  cardHeading,
  date,
  text,
  warn,
  skipLink,
}
